import { go, type AdminTab } from "../../router";
import { getSession } from "../../session";
import { AdminOverview } from "./AdminOverview";
import { AdminAccounts } from "./AdminAccounts";
import { AdminAccount } from "./AdminAccount";
import { AdminUsers } from "./AdminUsers";

const TABS: Array<{ id: AdminTab; label: string }> = [
  { id: "overview", label: "Overview" },
  { id: "accounts", label: "Accounts" },
  { id: "users", label: "Users" },
];

export function Admin({ tab, id }: { tab: AdminTab; id?: string }) {
  const session = getSession();
  if (!session?.account.platform_admin) {
    return (
      <div className="page" style={{ padding: "60px 40px", color: "var(--text-4)" }}>
        No such page.
      </div>
    );
  }

  return (
    <div className="page" style={{ paddingTop: 34 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <h1>Admin</h1>
        <span className="sub" style={{ maxWidth: 660 }}>
          Who signed up, what shape their workspace is in, and the support actions
          that should never live on a tenant surface.
        </span>
      </div>

      <nav style={{ display: "flex", gap: 6, marginTop: 22, marginBottom: 8 }}>
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={tab === t.id && !id ? "btn-accent" : "btn-ghost"}
            aria-current={tab === t.id && !id}
            onClick={() => go({ name: "admin", tab: t.id })}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {id ? <AdminAccount id={id} />
        : tab === "users" ? <AdminUsers />
        : tab === "accounts" ? <AdminAccounts />
        : <AdminOverview />}
    </div>
  );
}
